import { SxProps, Theme } from "@mui/material";

export const containerStyles: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  gap: theme.spacing(2),
  bgcolor: "background.default"
});

export const messageStyles: SxProps<Theme> = (theme) => ({
  marginTop: theme.spacing(1)
});
